import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { User } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class UserService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getUser(id, schema: { id: null; name: null }): Promise<User> {
    return new User(await this.core.services.user.getById(id, schema))
  }

  async getUsers(
    parameters: any = {
      sort: 'name',
      direction: 'asc',
    },
    schema: any = { id: null, name: null }
  ): Promise<{
    items: User[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.user.getList(parameters, schema)
  }

  createUser(user: Partial<User>, schema: User | Partial<User>): any {
    // createUser(user: any, schema: any): any {
    return this.core.services.user.create(user, schema)
  }

  updateUser(user: Partial<User>, schema: User | Partial<User>): Promise<User | Partial<User>> {
    return this.core.services.user.update(user, schema)
  }

  deleteUser(user: Partial<User>): Promise<User> {
    // deleteUser(user: any): Promise<any> {
    return this.core.services.user.delete(user)
  }
}
